exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ant-popover.dmp-antd-component .ant-popover-content .ant-popover-arrow {\n  display: none;\n}\n.ant-popover.dmp-antd-component .ant-popover-content .ant-popover-inner {\n  background: #3b3f4b;\n  border-radius: 0;\n  box-shadow: none;\n  color: #ededf1;\n}\n.ant-popover.dmp-antd-component .ant-popover-content .ant-popover-inner .ant-popover-inner-content {\n  color: #ededf1;\n  padding: 0;\n}\n.ant-popover.dmp-antd-component.ant-popover-placement-bottomLeft,\n.ant-popover.dmp-antd-component.ant-popover-placement-bottomRight,\n.ant-popover.dmp-antd-component.ant-popover-placement-bottom {\n  padding-top: 0;\n}\n", ""]);

// exports
